
import TableList from "@components/templates/tablelist";
import { HttpGetDisCountList, HttpDeleteDisCountOne } from "@/service/fedex";
import { mapGetters } from "vuex";
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetDisCountList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'fedexUpdateDiscount',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'fedexUpdateDiscount',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexUpdateDiscount",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        desc: this.$t('fbb.localemanage.confirm_delete',{defaultValue:'删除后不可恢复，是否确认删除？'}),
                        ajaxRequest: HttpDeleteDisCountOne
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/fedexCostDiscount/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: this.$t('fbb.alloment.query_detail',{defaultValue:'查看详情'}),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit',{defaultValue:'编辑'}),
                show: true,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.delete',{defaultValue:'删除'}),
                show: true,
                params: id,
                operate: 'delete'
            }]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add',{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('fbb.alloment.muti_export',{defaultValue:'批量导出'}),
                    operate: "export",
                    // more: true,
                    theme: "success"
                },
            ]
        },
        typeList() {
            return [
                { value: 'ACCOUNT', label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}) },
                { value: 'ACCOUNT_SERVICE', label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'})+'+'+ this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}) },
                { value: 'ACCOUNT_SERVICE_WEIGHT', label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'})+'+'+ this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'})+'+'+this.$t('global.common.weight',{defaultValue:'重量'}) },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
                    tag: 'vInput',
                    key: 'EQ_account',
                    show: true,
                },
                {
                    // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    label: "承运商服务",
                    tag: 'vSelect',
                    key: 'EQ_carrierServiceCode',
                    show: true,
                    options: this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.product_channel.type',{defaultValue:'类型'}),
                    tag: 'vSelect',
                    key: 'EQ_discountType',
                    show: true,
                    options: this.typeList,
                    props: {
                        filterable: true,
                    }
                },
            ]
        },
        columns() {
            return [{
                title: this.$t('global.common.actions',{defaultValue:'操作'}),
                maxWidth: 90,
                render: this.getOperateNodes
            }, {
                title: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
                key: 'account',
            },
            {
                title: this.$t('erp.product_channel.type',{defaultValue:'类型'}),
                render: (h,{row}) =>{
                    switch (row.discountType) {
                        case "ACCOUNT": return <div>{this.$t('fbb.fedexcost.account',{defaultValue:''})}</div>; break;
                        case "ACCOUNT_SERVICE": return <div>{this.$t('fbb.fedexcost.account',{defaultValue:'账户'})+'+'+ this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'})}</div>; break;
                        case "ACCOUNT_SERVICE_WEIGHT": return <div>{this.$t('fbb.fedexcost.account',{defaultValue:'账户'})+'+'+ this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'})+'+'+this.$t('global.common.weight',{defaultValue:'重量'})}</div>; break;
                    }
                }
            },
            {
                // title: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                title: "承运商服务",
                key:'carrierServiceCode'
                // render: (h,{row}) =>{
                //     return <div>{row.carrierCode} ({row.carrierServiceCode})</div>
                // }
            },
            {
                title: this.$t('fbb.account.cusdisacountrate_weight_min',{defaultValue:'重量区间最小值'})+'(lbs)',
                key: 'weightRangeMin',
            },
            {
                title: this.$t('fbb.account.cusdisacountrate_weight_max',{defaultValue:'重量区间最大值'})+'(lbs)',
                key: 'weightRangeMax',
            },
            {
                title: this.$t('fbb.account.cusdisacountrate_rate ',{defaultValue:'折扣率'}),
                key: 'discount',
            },
            ];
        },

    },

};
